export default __webpack_public_path__ + "static/media/angler.dc5665a3.png";